import is_IS from '../../date-picker/locale/is_IS'
export default is_IS



// WEBPACK FOOTER //
// ./components/calendar/locale/is_IS.js